import Vue from "vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";

Vue.filter("numFormat", numFormat(numeral));

Vue.filter("makeHidden", function(value) {
  if (!value) return "";
  let prfxlen = value.indexOf("@") - 1;
  let hlen = parseInt(prfxlen / 2);
  let prfx = "";
  for (let i = 0; i < hlen; i++) prfx += "*";
  return value.replace(value.substring(hlen, prfxlen), prfx);
});

Vue.filter("uppercase", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.toUpperCase();
});

Vue.filter("substring", function(value, from, to) {
  if (!value) return "";
  value = value.toString();
  return value.substring(from || 0, to || 0);
});

Vue.filter("renderSymbol", function(value) { 
  if (!value) return "";
  if (value == "BTC") return "Ƀ";
  if (value == "USDT") return "$";
  if (value == "USD") return "$";
});

Vue.filter("splitPrice", function(value, part) {
  let splited = value.toString().split(".");
  return part == "cents" ? "." + splited[1] : splited[0];
});

Vue.filter("expToFloat", function(exponentialNumber) {
  const str = Math.abs(exponentialNumber).toString();
  if (str.indexOf("e") !== -1) {
    const exponent = parseInt(str.split("-")[1], 10);
    const result = exponentialNumber.toFixed(exponent);
    return result;
  } else {
    return exponentialNumber;
  }
});

Vue.filter("obfuscate", function(str, len) {
  return (
    str.substring(0, len) +
    "..." +
    str.substring(str.length - len, str.length - 1)
  );
});

Vue.filter("formatMoney", function(str, separator = " ") {
  return String(str).replace(/\d(?=(\d{3})+\.)/g, "$&" + separator);
});


Vue.filter("truncateEthAddress", function(address) {
  const truncateRegex = /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/;
  const match = address.match(truncateRegex);
  if (!match) return address;
  return `${match[1]}…${match[2]}`;
});
Vue.filter("formatCurrency", function (v) {
  const formatted = v.toFixed(2).split('.');
  return `<span>${formatted[0]}.</span><span style="color:#CCD2E3">${formatted[1]}</span>`
});